import { HttpQueryConfig } from '../../core/model/HttpQueryConfig.model';

export const L3ServiceLocationsHttpQuery: HttpQueryConfig = {
  GetL3ServiceLocations: {
    key: 'GetL3ServiceLocations',
    url: '/api/customers/{customerId}/l3-service-locations',
    errors: {},
  },
  GetL3ServiceDetails: {
    key: 'GetL3ServiceDetails',
    url: '/api/customers/{customerId}/l3-services/{itemId}',
    errors: {},
  },
  PatchL3ServiceLocation: {
    key: 'PatchL3ServiceLocation',
    url: '/api/customers/{customerId}/l3-service-locations/{itemId}',
    errors: {},
  }
};